export default "__VITE_ASSET__DhyT6sV$__"